<script>
  export let threshold = 1
  export let rootMargin = '10% 0px -10% 0px'

  let visible = false
  let ratio = 0
  $: console.log(visible)

  function intersection(node) {
    const prefersReducedMotion =
      !document.body.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) {
      visible = true
      return
    }
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible = true
            // observer.unobserve(entry.target)
          }
        }
      },
      {
        threshold,
        rootMargin,
      },
    )
    observer.observe(node)
  }
</script>

<div use:intersection>
  <slot {visible} {ratio} />
</div>
